import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReloadModalService } from './reload-modal.service';

// See documentation:
// https://angular.dev/ecosystem/service-workers/communications
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(
    private readonly swUpdate: SwUpdate,
    private readonly reloadModalService: ReloadModalService
  ) {}

  // https://angular.dev/ecosystem/service-workers/communications#handling-an-unrecoverable-state
  subscribeUpdates() {
    // The service worker checks for updates during initialization
    // and on each navigation request —that is, when the user navigates
    // from a different address to your application
    this.swUpdate.versionUpdates.pipe(untilDestroyed(this)).subscribe((event) => {
      switch (event.type) {
        case 'VERSION_DETECTED':
          console.debug(`Downloading new app version: ${event.version.hash}`);
          break;
        case 'VERSION_READY':
          console.debug(`Current app version: ${event.currentVersion.hash}`);
          console.debug(`New app version ready for use: ${event.latestVersion.hash}`);
          this.reloadModalService.showWarning({
            title: $localize`Nieuwe versie beschikbaar`,
            content: $localize`Gelieve de pagina te herladen. Uw niet-opgeslagen wijzigingen gaan verloren.`,
            okText: $localize`Herladen`,
          });
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.error(`Failed to install app version '${event.version.hash}': ${event.error}`);
          break;
      }
    });
  }

  // https://angular.dev/ecosystem/service-workers/communications#handling-an-unrecoverable-state
  subscribeUnrecoverableStateHandler() {
    this.swUpdate.unrecoverable.pipe(untilDestroyed(this)).subscribe((event) => {
      this.reloadModalService.showWarning({
        title: $localize`Niet-herstelbare error`,
        content: $localize`Er heeft zich een onverwacht probleem voorgedaan:\n${event.reason}\n\nGelieve de pagina te herladen.`,
        okText: $localize`Herladen`,
      });
    });
  }
}
